import { Injectable } from '@angular/core';

export type ValidationDecision = 'Terminado' | 'Realizar ajustes' | 'Validado';
export type ValidationStatus = 'Por validar' | 'En ajustes' | 'Terminado' | 'Validado' | 'En implementación';

export interface ValidationAudit {
  authority: string;
  registeredAt: string;
  decision: ValidationDecision;
  observation: string;
  attachmentName?: string;
}

export interface ValidationProject {
  id: string;
  name: string;
  submittedAt: string;
  registeredBy: string;
  status: ValidationStatus;
  authorities: string[];
  hasImplementer: boolean;
  otherAuthorityDecision?: ValidationDecision;
  audit?: ValidationAudit;
}

@Injectable({ providedIn: 'root' })
export class ProjectValidationService {
  readonly currentAuthority = 'Corpocesar';
  private projects: ValidationProject[] = [
    { id: 'PSA-000002', name: 'Conservación Serranía del Perijá', submittedAt: '2026-07-12', registeredBy: 'Andrés Rojas', status: 'Por validar', authorities: ['Corpocesar'], hasImplementer: true },
    { id: 'PSA-000004', name: 'Protección hídrica cuenca del Cesar', submittedAt: '2026-07-11', registeredBy: 'Laura Martínez', status: 'Por validar', authorities: ['Corpocesar', 'Corponor'], hasImplementer: false, otherAuthorityDecision: 'Realizar ajustes' },
    { id: 'PSA-000003', name: 'Restauración cuenca alta', submittedAt: '2026-07-08', registeredBy: 'Camila Torres', status: 'En ajustes', authorities: ['Corpocesar'], hasImplementer: false, audit: { authority: 'Corpocesar', registeredAt: '2026-07-10 10:35', decision: 'Realizar ajustes', observation: 'Ajuste la delimitación del área prioritaria y adjunte el soporte de propiedad del predio PR-001.', attachmentName: 'observaciones-aac.pdf' } }
  ];

  pendingForCurrentAuthority(): ValidationProject[] {
    return this.projects.filter(project => project.status === 'Por validar' && project.authorities.includes(this.currentAuthority));
  }

  find(id: string): ValidationProject | undefined { return this.projects.find(project => project.id === id); }

  submitRegistrationProject(): ValidationProject {
    const existing = this.find('PSA-000002');
    if (existing) { existing.status = 'Por validar'; existing.audit = undefined; return existing; }
    const project: ValidationProject = { id: 'PSA-000002', name: 'Conservación Serranía del Perijá', submittedAt: '2026-07-12', registeredBy: 'Andrés Rojas', status: 'Por validar', authorities: ['Corpocesar'], hasImplementer: true };
    this.projects.push(project);
    return project;
  }

  resolve(id: string, decision: ValidationDecision, observation: string, attachmentName?: string): ValidationProject | undefined {
    const project = this.find(id);
    if (!project) return undefined;
    const finalStatus: ValidationStatus = decision === 'Terminado'
      ? 'Terminado'
      : decision === 'Realizar ajustes'
        ? 'En ajustes'
        : project.authorities.length > 1 && project.otherAuthorityDecision && project.otherAuthorityDecision !== decision
          ? 'En ajustes'
          : 'Validado';
    project.status = finalStatus;
    project.audit = { authority: this.currentAuthority, registeredAt: '2026-07-12 14:30', decision, observation, attachmentName };
    return project;
  }
}
